"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var TopicMore = function TopicMore(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return (0, _preact.h)("li", {
    className: "post__action-item post-footer-item text--meta post-footer-item_show-more ".concat(className !== null && className !== void 0 ? className : '')
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)(_MoreHoriz.default, {
      width: 16,
      height: 16
    }),
    tooltipMessage: (0, _preact.h)("ul", {
      className: "post-footer-item_show-more-list"
    }, children)
  }));
};

var _default = TopicMore;
exports.default = _default;